import { createRouter, createWebHistory } from 'vue-router'

import MainLayout from '@/layouts/MainLayout.vue'
import SpmiLayout from '@/layouts/SpmiLayout.vue'

import SimakadAbout from '@/views/simakad/SimakadAbout.vue'
import SpmiHome from '@/views/spmi/SpmiHome.vue'

import SimakadHome from '@/views/simakad/SimakadHome.vue'
import BeritaByCategory from '@/views/simakad/berita/BeritaByCategory.vue'
import DetailBerita from '@/views/simakad/berita/DetailBerita.vue'

const routes = [
  {
    path: '/',
    component: MainLayout,
    children: [
      {
        path: '',
        name: 'SimakadHome',
        component: SimakadHome
      },{
        path: 'tentang',
        name: 'Tentang',
        component: SimakadAbout
      },
      {
        path: 'berita-by-category/:slug_cat',
        name: 'BeritaByCategory',
        component: BeritaByCategory
      },
      {
        path: ':slug_cat/:slug_berita',
        name: 'DetailBerita',
        component: DetailBerita
      },
    ]
  },
  {
    path: '/spmi',
    component: SpmiLayout,
    children: [
      {
        path: '',
        name: 'SpmiStandalone',
        component: SpmiHome
      }
    ]
  },
]

console.log('Router initialized with routes:', routes);

const router = createRouter({
  history: createWebHistory('/'), // Replaced process.env.BASE_URL with '/'
  routes
})

router.beforeEach((to, from, next) => {
  console.log('Navigating to:', to.path);
  next();
});

export default router
